import { KYMW0901Model } from '../kymw0901.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';

/**
 * 供給計画取得クラス
 *
 * @export GetChangeItemListService
 * @class GetChangeItemListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetChangeItemListService extends PlessJsonResponderSub<any> {

  // VO
  private model: KYMW0901Model = new KYMW0901Model;
  private vo = null;
  // 処理に使用するModel
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * API呼び出し
   *
   * @param model 処理に使用するモデル
   * @param vo vo
   * @param successFunc 成功時に実行される処理
   * @memberof GetChangeItemListService
   */
  execute(model: KYMW0901Model, vo: any = null, successFunc: Function = null): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('KYMW09getChangeItemList', new PlessRequest({}));
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetChangeItemListService
   */
  success(data: any): void {
    this.model.setCommonItemList(data);
    this.model.setItemCodeItemList(data);
    this.model.setCoopItemList(data);
    this.model.setChangeList(data);
    this.model.displayTabData = this.model.tabData[this.model.dataKeys[0]];
    if (this.successFunc) {
      this.successFunc();
    }
  }
}
